// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.4
// source: bridge/models/token.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "core.bridge";

export interface TokenInfo {
  address: string;
  decimals: string;
  chainId: string;
  tokenId: string;
  isWrapped: boolean;
  minWithdrawalAmount: string;
  commissionRate: string;
}

export interface TokenMetadata {
  name: string;
  symbol: string;
  uri: string;
  dexName: string;
}

export interface Token {
  id: string;
  metadata?:
    | TokenMetadata
    | undefined;
  /** info is the token information on different chains */
  info: TokenInfo[];
}

function createBaseTokenInfo(): TokenInfo {
  return {
    address: "",
    decimals: "0",
    chainId: "",
    tokenId: "0",
    isWrapped: false,
    minWithdrawalAmount: "",
    commissionRate: "",
  };
}

export const TokenInfo: MessageFns<TokenInfo> = {
  encode(message: TokenInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.address !== "") {
      writer.uint32(10).string(message.address);
    }
    if (message.decimals !== "0") {
      writer.uint32(16).uint64(message.decimals);
    }
    if (message.chainId !== "") {
      writer.uint32(26).string(message.chainId);
    }
    if (message.tokenId !== "0") {
      writer.uint32(32).uint64(message.tokenId);
    }
    if (message.isWrapped !== false) {
      writer.uint32(40).bool(message.isWrapped);
    }
    if (message.minWithdrawalAmount !== "") {
      writer.uint32(50).string(message.minWithdrawalAmount);
    }
    if (message.commissionRate !== "") {
      writer.uint32(58).string(message.commissionRate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokenInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.decimals = reader.uint64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.chainId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.tokenId = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isWrapped = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.minWithdrawalAmount = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.commissionRate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TokenInfo {
    return {
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      decimals: isSet(object.decimals) ? globalThis.String(object.decimals) : "0",
      chainId: isSet(object.chainId)
        ? globalThis.String(object.chainId)
        : isSet(object.chain_id)
        ? globalThis.String(object.chain_id)
        : "",
      tokenId: isSet(object.tokenId)
        ? globalThis.String(object.tokenId)
        : isSet(object.token_id)
        ? globalThis.String(object.token_id)
        : "0",
      isWrapped: isSet(object.isWrapped)
        ? globalThis.Boolean(object.isWrapped)
        : isSet(object.is_wrapped)
        ? globalThis.Boolean(object.is_wrapped)
        : false,
      minWithdrawalAmount: isSet(object.minWithdrawalAmount)
        ? globalThis.String(object.minWithdrawalAmount)
        : isSet(object.min_withdrawal_amount)
        ? globalThis.String(object.min_withdrawal_amount)
        : "",
      commissionRate: isSet(object.commissionRate)
        ? globalThis.String(object.commissionRate)
        : isSet(object.commission_rate)
        ? globalThis.String(object.commission_rate)
        : "",
    };
  },

  toJSON(message: TokenInfo): unknown {
    const obj: any = {};
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.decimals !== "0") {
      obj.decimals = message.decimals;
    }
    if (message.chainId !== "") {
      obj.chainId = message.chainId;
    }
    if (message.tokenId !== "0") {
      obj.tokenId = message.tokenId;
    }
    if (message.isWrapped !== false) {
      obj.isWrapped = message.isWrapped;
    }
    if (message.minWithdrawalAmount !== "") {
      obj.minWithdrawalAmount = message.minWithdrawalAmount;
    }
    if (message.commissionRate !== "") {
      obj.commissionRate = message.commissionRate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TokenInfo>, I>>(base?: I): TokenInfo {
    return TokenInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TokenInfo>, I>>(object: I): TokenInfo {
    const message = createBaseTokenInfo();
    message.address = object.address ?? "";
    message.decimals = object.decimals ?? "0";
    message.chainId = object.chainId ?? "";
    message.tokenId = object.tokenId ?? "0";
    message.isWrapped = object.isWrapped ?? false;
    message.minWithdrawalAmount = object.minWithdrawalAmount ?? "";
    message.commissionRate = object.commissionRate ?? "";
    return message;
  },
};

function createBaseTokenMetadata(): TokenMetadata {
  return { name: "", symbol: "", uri: "", dexName: "" };
}

export const TokenMetadata: MessageFns<TokenMetadata> = {
  encode(message: TokenMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.symbol !== "") {
      writer.uint32(18).string(message.symbol);
    }
    if (message.uri !== "") {
      writer.uint32(26).string(message.uri);
    }
    if (message.dexName !== "") {
      writer.uint32(34).string(message.dexName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TokenMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTokenMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.symbol = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.uri = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.dexName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TokenMetadata {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : "",
      uri: isSet(object.uri) ? globalThis.String(object.uri) : "",
      dexName: isSet(object.dexName)
        ? globalThis.String(object.dexName)
        : isSet(object.dex_name)
        ? globalThis.String(object.dex_name)
        : "",
    };
  },

  toJSON(message: TokenMetadata): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.symbol !== "") {
      obj.symbol = message.symbol;
    }
    if (message.uri !== "") {
      obj.uri = message.uri;
    }
    if (message.dexName !== "") {
      obj.dexName = message.dexName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TokenMetadata>, I>>(base?: I): TokenMetadata {
    return TokenMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TokenMetadata>, I>>(object: I): TokenMetadata {
    const message = createBaseTokenMetadata();
    message.name = object.name ?? "";
    message.symbol = object.symbol ?? "";
    message.uri = object.uri ?? "";
    message.dexName = object.dexName ?? "";
    return message;
  },
};

function createBaseToken(): Token {
  return { id: "0", metadata: undefined, info: [] };
}

export const Token: MessageFns<Token> = {
  encode(message: Token, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "0") {
      writer.uint32(8).uint64(message.id);
    }
    if (message.metadata !== undefined) {
      TokenMetadata.encode(message.metadata, writer.uint32(18).fork()).join();
    }
    for (const v of message.info) {
      TokenInfo.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Token {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToken();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = TokenMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.info.push(TokenInfo.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Token {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "0",
      metadata: isSet(object.metadata) ? TokenMetadata.fromJSON(object.metadata) : undefined,
      info: globalThis.Array.isArray(object?.info) ? object.info.map((e: any) => TokenInfo.fromJSON(e)) : [],
    };
  },

  toJSON(message: Token): unknown {
    const obj: any = {};
    if (message.id !== "0") {
      obj.id = message.id;
    }
    if (message.metadata !== undefined) {
      obj.metadata = TokenMetadata.toJSON(message.metadata);
    }
    if (message.info?.length) {
      obj.info = message.info.map((e) => TokenInfo.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Token>, I>>(base?: I): Token {
    return Token.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Token>, I>>(object: I): Token {
    const message = createBaseToken();
    message.id = object.id ?? "0";
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? TokenMetadata.fromPartial(object.metadata)
      : undefined;
    message.info = object.info?.map((e) => TokenInfo.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
